{"host_assets_ssl":"https://cdn-assets.dzcdn.net/shaker","appUrl":"https://shaker.deezer.com","host_commons_assets_ssl":"https://cdn-assets.dzcdn.net/common"}